<template>
    <div class="flex mb-px draggable relative">
        <!-- Draggable handle. -->
        <div class="w-6 flex-shrink-0 py-1.5 -my-px border-t bg-white">
            <div class="w-5 h-5 flex items-center">
            </div>
        </div>
        <div class="w-8 -ml-px flex">
            <span class="flex-grow -my-px lm-0 border border-gray-200 p-1 text-gray-400 italic bg-white"
                  v-text="index+1"></span>
        </div>
        <!-- Description. -->
        <div class="flex flex-col flex-1 m-0 relative">
            <div class="flex flex-1 m-0 relative">
                <div :key="itemRenderKey"
                     class="flex flex-1 m-0 -ml-px -mt-px mr-px -mb-px border-l border-t border-b border-gray-200 shadow-none min-w-24 relative">
                    <div
                        class="text-xs mx-0 m-0 p-0 border-none text-blue-600 flex w-full"
                    >
                        <autoresizable-textarea :height="el => (el.scrollHeight ) + 'px'"
                                                ref="autoresizable-description">
                            <div
                                class="text-sm text-gray-600 px-2 bg-white m-0 flex-grow pt-1 pb-1 placeholder:text-gray-400 shadow-none relative focus:border-blue-500 border-none focus:z-20 resize-none whitespace-pre-wrap"
                                v-html="highlight(itemClone.description)" ref="description"
                            >
                            </div>
                        </autoresizable-textarea>
                    </div>
                </div>
                <div class="w-20 -ml-px flex relative">
                    <page-cell
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Qty..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        ref="quantity"
                        v-model="itemClone.quantity"
                    ></page-cell>
                </div>
                <div class="w-16 -ml-px flex">
                    <page-cell
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="UoM..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.unitOfMeasure"
                    ></page-cell>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        :class="rateRounded?'text-gray-400':''"
                        placeholder="Rate..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.rate"
                    ></page-cell>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Net..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.net"
                    ></page-cell>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Discount..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.discountValue"
                    ></page-cell>
                </div>
                <div class="w-16 -ml-px flex">
                    <page-cell
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Vat %..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.vatPercentage"
                    ></page-cell>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Vat..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.vatValue"
                    ></page-cell>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Total..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.value"
                    ></page-cell>
                </div>
            </div>
            <div class="flex flex-1 m-0 relative" v-if="this.showDeliveryOptions">
                <div class="flex">
                    <div ref="packageSearch"
                         class="text-xs mx-0 -mt-px p-0 border-none text-blue-600"
                    >
                        <div class="flex truncate mt-1 mb-0">
                            <div
                                class="text-xs px-1.5 py-0.5 text-blue-600 ml-1 my-0.5 truncate whitespace-nowrap"
                                :class="!readonly?'hover:underline cursor-pointer':''">
                                <span class="fas mr-0.5" :class="item.packageReference?'fa-cube':'fa-warehouse'"></span>
                                <span
                                    v-text="(item.packageName?item.packageName:'Not related to a package')"></span>
                            </div>
                        </div>
                    </div>
                    <div class="flex my-1">
                        <div class="text-xs px-1.5 py-0.5 text-gray-600 ml-1 mt-0.5 mb-0">
                            <div class="inline-block text-xs mx-0 -mt-px p-0 border-none text-blue-600">
                                <span class="fas mr-0.5"
                                      :class="!item.deliveryOption?'fa-question text-gray-400':(item.deliveryOption.isDelivery?'fa-truck text-blue-500':'fa-people-carry text-blue-500')">
                                </span>
                                <span class="mr-1 font-bold"
                                      :class="!item.deliveryOption?'text-gray-400':(item.deliveryOption.isDelivery?'text-blue-500':'text-blue-500')">
                                    {{ (!item.deliveryOption || item.deliveryOption.isDelivery ? 'Delivery:' : 'Collection:') }}
                                </span>
                                <span class=""
                                      :class="((item.deliveryOption && item.deliveryOption.address)?'text-blue-500':'text-gray-400')+(!readonly?' hover:underline cursor-pointer':'')">
                                    <template v-if="item.deliveryOption && item.deliveryOption.address">
                                        <span class="pr-1"
                                              v-for="line in addressLines(item.deliveryOption)"
                                              v-text="line">
                                        </span>
                                    </template>
                                    <div v-else class="inline-block">No address set</div>
                                    <span class="pr-1"
                                          v-if="item.deliveryOption && item.deliveryOption.contactName">-</span>
                                    <span class="mx-0" v-if="item.deliveryOption && item.deliveryOption.contactName"
                                          v-text="item.deliveryOption.contactName + (item.deliveryOption.contactNumber?'(' + item.deliveryOption.contactNumber + ')':'')"></span>
                                </span>
                            </div>
                            <span class="pr-1" v-if="item.deliveryOption">-</span>
                            <div class="relative inline" v-if="item.deliveryOption"
                            >
                                <ui-date-picker v-model="date"
                                                ref="datepicker"
                                                :with-time="false"
                                                class="absolute top top-0 left-0 opacity-0 block max-h-4 max-w-0 overflow-hidden"
                                                field="absolute top top-0 left-0 opacity-0 block max-h-4 max-w-0 overflow-hidden"
                                ></ui-date-picker>
                                <span
                                    :class="((item.deliveryOption && item.deliveryOption.date)?'text-blue-500':'text-blue-500')+(!readonly?' hover:underline cursor-pointer':'')"
                                    v-text="(item.deliveryOption && item.deliveryOption.date)?moment(item.deliveryOption.date).format('MMMM Do, YYYY'):'ASAP'"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-6 flex-shrink-0 bg-white border-t -mt-px border-gray-200">
        </div>
    </div>
</template>

<script>

import {resolveNumericText, toCurrency} from "../../../../utils";
import * as math from 'mathjs';
import _ from "lodash";
import moment from "moment";

export default {
    computed: {
        moment() {
            return moment
        }
    },
    components: {},
    props: {
        index: Number,
        item: Object,
        readonly: {type: Boolean, default: false},
        addresses: Array,
        purchaseOrder: {type: Object, default: null},
        highlight: Function,
        showDeliveryOptions: {type: Boolean, default: false},
    },
    data() {
        return {
            date: null,
            itemClone: {},
            itemKey: 0,
            quantity: this.item.quantity ? this.item.quantity : '',
            packageName: this.item.packageName,
            rateRounded: (resolveNumericText(this.item.rate) !== ((resolveNumericText(this.item.net) / resolveNumericText(this.item.quantity)))),
            deliveryOptionDateKey: 0,
            itemRenderKey: 0,
        }
    },
    watch: {
        readonly: function () {
            this.$nextTick(() => {
                this.resize();
            })
        }
    },
    methods: {
        adjustRFMResolves() {
            this.$modals.open('PurchaseOrderResolvePOToRFMs', {
                purchaseOrder: this.purchaseOrder,
                purchaseOrderItem: this.item,
                handle: async (modal) => {
                    this.itemClone.resolves = modal.resolves;
                    Object.assign(this.item, this.itemClone)
                    this.update();
                    modal.close()
                },
            })

        },
        resolvesAsTree(resolves) {
            let tree = []
            if (resolves) {
                resolves.forEach((item) => {
                    let rfm = tree.find((i) => i.id === item.rfm.id);
                    if (!rfm) {
                        rfm = {id: item.rfm.id, reference: item.rfm.reference, items: []}
                        tree.push(rfm)
                    }
                    rfm.items.push(item);
                })
            }
            return tree;
        },
        resize() {
            this.$refs['autoresizable-description'].forceResize()
        },
        openPackageSearch(open) {
            if (!this.readonly) {
                open();
                this.$nextTick(() => {
                    this.$refs.packageSearch.focus()
                })
            }
        },
        openAddressSearch(open) {
            if (!this.readonly) {
                open();
            }
        },
        openDatePicker() {
            if (!this.readonly) {
                this.$refs.datepicker.flatpickr.open()
            }
        },
        addressLines(deliveryOption) {
            let data = deliveryOption.address.trim();
            data = data.replace(/\n/g, ", ").trim();
            data = data.replace(/, ,/g, '').split(', ');
            let option = data.splice(-1, 1)
            data = data.map(item => {
                return item.trim() + ',';
            })
            if (option.length > 0) {
                data.push(option[0]);
            }
            return data;
        },
        updateAddresses(items, addressData) {
            this.$emit("updateAddresses", items, addressData);
        },
        setAddress(op) {
            this.$emit("setAddress", this.item, op.addressData);
        },
        addAddress(op) {
            this.$emit("addAddress", this.item, op.addressData);
        },
        clearAddress() {
            this.$emit("clearAddress", this.item);
        },
        toggleCollection(p) {
            if (!this.item.deliveryOption) {
                this.item.deliveryOption = {
                    isDelivery: false,
                    address: null,
                    date: null
                };
            }
            this.item.deliveryOption.isDelivery = p
            Object.assign(this.itemClone, this.item)
            this.update();
        },
        updateDate() {
            if (!this.item.deliveryOption) {
                this.item.deliveryOption = {
                    isDelivery: false,
                    address: null,
                    date: null
                };
            }
            if (this.item.deliveryOption.date === this.date) {
                this.date = null
            }
            this.item.deliveryOption.date = this.date;
            Object.assign(this.itemClone, this.item)
            this.update()
        },
        updateQuantity(finished) {
            let v = resolveNumericText(this.itemClone.quantity, false);
            this.itemClone.net = toCurrency(resolveNumericText(this.itemClone.rate) * v);
            this.itemClone.vatValue = toCurrency((resolveNumericText(this.itemClone.net, false) / 100) * resolveNumericText(this.itemClone.vatPercentage));
            this.itemClone.value = toCurrency(resolveNumericText(this.itemClone.net, false) + resolveNumericText(this.itemClone.vatValue, false));
            if (finished) {
                this.itemClone.quantity = resolveNumericText(this.itemClone.quantity, false);
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.quantity = resolveNumericText(this.itemClone.quantity, false);
                Object.assign(this.item, _.omit(this.itemClone, ['quantity']))
            }
            this.rateRounded = (resolveNumericText(this.itemClone.rate, true) !== ((resolveNumericText(this.itemClone.net, true) / resolveNumericText(this.itemClone.quantity, true))))
            this.update();
        },
        updateRate(finished) {
            let v = resolveNumericText(this.itemClone.rate, false);
            let q = resolveNumericText(this.itemClone.quantity, false);
            if (((q < 0) && (v > 0)) || ((q > 0) && (v < 0))) {
                v = 0 - v;
            }
            this.itemClone.net = toCurrency(resolveNumericText(this.itemClone.quantity) * v);
            this.itemClone.vatValue = toCurrency((resolveNumericText(this.itemClone.net, false) / 100) * resolveNumericText(this.itemClone.vatPercentage));
            this.itemClone.value = toCurrency(resolveNumericText(this.itemClone.net, false) + resolveNumericText(this.itemClone.vatValue, false));
            if (finished) {
                this.itemClone.rate = toCurrency(resolveNumericText(this.itemClone.rate));
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.rate = toCurrency(resolveNumericText(this.itemClone.rate));
                Object.assign(this.item, _.omit(this.itemClone, ['rate']))
            }
            this.rateRounded = (resolveNumericText(this.itemClone.rate) !== ((resolveNumericText(this.itemClone.net) / resolveNumericText(this.itemClone.quantity))))
            this.update();
        },
        updateNet(finished) {
            let v = resolveNumericText(this.itemClone.net, false);
            let q = resolveNumericText(this.itemClone.quantity, false);
            if (((q < 0) && (v > 0)) || ((q > 0) && (v < 0))) {
                v = 0 - v;
            }
            this.itemClone.rate = toCurrency(q ? (v / q) : 0);
            this.itemClone.vatValue = toCurrency((v / 100) * resolveNumericText(this.itemClone.vatPercentage));
            this.itemClone.value = toCurrency(v + resolveNumericText(this.itemClone.vatValue, false));
            if (finished) {
                this.itemClone.net = toCurrency(v);
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.net = toCurrency(v);
                Object.assign(this.item, _.omit(this.itemClone, ['net']))
            }
            this.rateRounded = (resolveNumericText(this.itemClone.rate) !== ((resolveNumericText(this.itemClone.net) / resolveNumericText(this.itemClone.quantity))))
            this.update();
        },
        updateVatPercentage(finished) {
            let v = math.round(resolveNumericText(this.itemClone.vatPercentage.trim('%')), 2)
            this.itemClone.vatValue = toCurrency((resolveNumericText(this.itemClone.net, false) / 100) * v);
            this.itemClone.value = toCurrency(resolveNumericText(this.itemClone.net, false) + resolveNumericText(this.itemClone.vatValue, false));
            if (finished) {
                this.itemClone.vatPercentage = (0 + v) + '%';
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.vatPercentage = (0 + v) + '%';
                Object.assign(this.item, _.omit(this.itemClone, ['vatPercentage']))
            }
            this.update();
        },
        updateVatValue(finished) {
            let v = resolveNumericText(this.itemClone.vatValue, false);
            let n = resolveNumericText(this.itemClone.net, false);
            let q = resolveNumericText(this.itemClone.quantity, false);
            if (((q < 0) && (v > 0)) || ((q > 0) && (v < 0))) {
                v = 0 - v;
            }
            let valp = math.round((n ? 100 / n : 0) * v, 2) + '%';
            let val = toCurrency(resolveNumericText(this.itemClone.net, false) + v);
            if (val !== this.itemClone.value) {
                this.itemClone.vatPercentage = valp;
                this.itemClone.value = val;
            }

            if (finished) {
                this.itemClone.vatValue = toCurrency(v);
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.vatValue = toCurrency(v);
                Object.assign(this.item, _.omit(this.itemClone, ['vatValue']))
            }
            this.update();
        },
        updateUom() {
            Object.assign(this.item, this.itemClone)
            this.update();
        },
        updateValue(finished) {
            let v = resolveNumericText(this.itemClone.value, false);
            let q = resolveNumericText(this.itemClone.quantity, false);
            if (((q < 0) && (v > 0)) || ((q > 0) && (v < 0))) {
                v = 0 - v;
            }
            this.itemClone.net = toCurrency((v / (1 + (resolveNumericText(this.itemClone.vatPercentage) / 100))));
            let n = resolveNumericText(this.itemClone.net, false);
            this.itemClone.rate = toCurrency(q ? (n / q) : 0);
            this.itemClone.vatValue = toCurrency((n / 100) * resolveNumericText(this.itemClone.vatPercentage));
            if (finished) {
                this.itemClone.value = toCurrency(v);
                Object.assign(this.item, this.itemClone)
            } else {
                Object.assign(this.item, _.omit(this.itemClone, ['value']))
                this.item.value = toCurrency(v);
            }
            this.rateRounded = (resolveNumericText(this.itemClone.rate) !== ((resolveNumericText(this.itemClone.net) / resolveNumericText(this.itemClone.quantity))))
            this.update();
        },
        updateDescription() {
            Object.assign(this.item, this.itemClone)
            this.update();
        },
        update() {
            this.$emit('updated');
        },
        setPackage(op) {
            let update = async () => {
                this.itemClone.packageReference = op.packageItem ? op.packageItem.referenceNumber : null;
                this.itemClone.packageName = op.packageItem ? op.packageItem.name : null;
                this.item.packageReference = op.packageItem ? op.packageItem.referenceNumber : null;
                this.item.packageName = op.packageItem ? op.packageItem.name : null;
                this.update();
            }
            if (this.itemClone.resolves.length) {
                this.$modals.confirm({
                    title: `Do you want to update the Package?`,
                    button: 'Yes, update the Package',
                    paragraphs: ['This will clear the proposed RFM resolves on this item, as they will no longer be valid when changing the package.'],
                    handle: async () => {
                        this.item.resolves = []
                        this.itemClone.resolves = []
                        update()
                        this.itemRenderKey++;
                    }
                })
            } else {
                update();
            }
        },
        selectMaterial(rfm, material) {
            this.itemClone.description = material.material;
            this.itemClone.unitOfMeasure = material.unitOfMeasure;
            this.itemClone.quantity = material.required;
            this.toggleResolve(rfm, material);
            if (this.itemClone.resolves.length > 1) {
                this.itemClone.resolves = [];
                this.toggleResolve(rfm, material);
            }
            Object.assign(this.item, this.itemClone)
            this.update();
            this.itemRenderKey++;
            // Give time to close down dropdown
            setTimeout(() => {
                this.$refs.quantity.focusAsNew()
            }, 50)
        },
        addMaterial(rfm, material) {
            this.itemClone.description = material.material;
            this.itemClone.unitOfMeasure = material.unitOfMeasure;
            this.toggleResolve(rfm, material);
            this.itemClone.quantity = this.itemClone.resolves.reduce((a, c) => a + c.quantity, 0)
            Object.assign(this.item, this.itemClone)
            this.update();
        },
        toggleResolve(rfm, material) {
            let index = this.itemClone.resolves.findIndex((i) => (i.rfm.id === rfm.id) && (i.rfm.item.id === material.id));
            if (index > -1) {
                this.itemClone.resolves.splice(index, 1);
            } else {
                this.itemClone.resolves.push({
                    rfm: {
                        id: rfm.id,
                        reference: rfm.reference,
                        packageReference: rfm.packageReference,
                        item: {
                            id: material.id,
                            material: material.material,
                            unitOfMeasure: material.unitOfMeasure,
                            required: material.required
                        },
                    },
                    quantity: material.required
                });
            }
        },
        resetPackage() {
            if (!this.packageName) {
                this.itemClone.packageReference = null
                this.itemClone.packageName = null
                this.item.packageReference = null
                this.item.packageName = null
            }
            this.packageName = this.itemClone.packageName
            this.update();
        },
    },
    mounted() {
        this.itemClone = structuredClone(this.item)
        this.itemClone.rate = toCurrency(resolveNumericText(this.itemClone.rate, false));
        this.itemClone.net = toCurrency(resolveNumericText(this.itemClone.net, false));
        this.itemClone.vatValue = toCurrency(resolveNumericText(this.itemClone.vatValue, false));
        this.itemClone.value = toCurrency(resolveNumericText(this.itemClone.value, false));
        this.rateRounded = (resolveNumericText(this.itemClone.rate) !== ((resolveNumericText(this.itemClone.net) / resolveNumericText(this.itemClone.quantity))))
        this.$nextTick(() => {
            this.resize()
        })
    }
}
</script>